import React from 'react';
import { useSelector } from 'react-redux';
import '../../styles/loading.css';

const LoadingOverlay = () => {
  const { isLoading } = useSelector((state) => state.loading);

  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-spinner">
        <img src="/logo/topsail-logo.png" alt="Topsail Roofing" className="loading-logo" />
        <div className="spinner"></div>
        <div className="loading-text">Loading...</div>
      </div>
    </div>
  );
};

export default LoadingOverlay; 